import { DEFAULT_LIVE_MAP_RIDE_FILTER } from "../../constants";
import { IRideTableDto } from "../../dto";
import { LiveMapRideFilterEnum, RideDelayStatusEnum } from "../../enums";
import { resolveLiveMapDelayStatusForDisplay } from "./live-map.helpers";

const LIVE_MAP_RIDE_FILTER_VALUES = new Set<string>(
  Object.values(LiveMapRideFilterEnum),
);

export const isLiveMapRideFilter = (
  value: unknown,
): value is LiveMapRideFilterEnum =>
  typeof value === "string" && LIVE_MAP_RIDE_FILTER_VALUES.has(value);

export const liveMapRideFilterTranslationKey = (
  filter: LiveMapRideFilterEnum,
): string => `rideMap.RIDE_FILTER_${filter}`;

export const resolveLiveMapRideFilter = (
  value: LiveMapRideFilterEnum | undefined,
): LiveMapRideFilterEnum => {
  if (value && isLiveMapRideFilter(value)) {
    return value;
  }

  return DEFAULT_LIVE_MAP_RIDE_FILTER;
};

export const isLiveMapRideVisibleForFilter = ({
  statusLate,
  filter,
}: {
  statusLate: RideDelayStatusEnum | null | undefined;
  filter: LiveMapRideFilterEnum;
}): boolean => {
  const resolvedStatus = resolveLiveMapDelayStatusForDisplay(statusLate);

  if (filter === LiveMapRideFilterEnum.all) {
    return true;
  }

  if (filter === LiveMapRideFilterEnum.hideNotTracked) {
    return resolvedStatus !== RideDelayStatusEnum.NOT_TRACKED;
  }

  if (filter === LiveMapRideFilterEnum.hideFuturePastNotTracked) {
    return (
      resolvedStatus !== RideDelayStatusEnum.FUTURE &&
      resolvedStatus !== RideDelayStatusEnum.PAST &&
      resolvedStatus !== RideDelayStatusEnum.NOT_TRACKED
    );
  }

  return true;
};

/** Filters live-map grid rows by toolbar ride-filter popover selection. */
export const filterLiveMapRowsByRideFilter = ({
  rides,
  filter,
}: {
  rides: readonly IRideTableDto[] | undefined;
  filter: LiveMapRideFilterEnum;
}): IRideTableDto[] => {
  if (!rides?.length || filter === LiveMapRideFilterEnum.all) {
    return rides ? [...rides] : [];
  }

  return rides.filter(ride =>
    isLiveMapRideVisibleForFilter({ statusLate: ride.statusLate, filter }),
  );
};
